<template>
    <div id="costs-table">
        <modals-container @importCategories="passImportCategories" @updateCategoryName="passUpdateCategoryName"
                          @budgetDone="passBudgetDone" @confirmCategory="confirmCategory" @addCategory="passAddCategory"
                          id="delete-row-modal"
                          @confirmDeleteRow="confirmDeleteRow"
                          @confirmLockUnlock="confirmLockUnlockBudget"
                          @confirmRemoveDocument="passConfirmRemoveDocument"
                          @confirmDeleteAdditionalBudget="passConfirmDeleteAdditionalBudget"
                          @confirmDeleteCategory="passConfirmDeleteCategory"
                          @deleteNote="passDeleteNote"
                          @addNote="passAddNote"
        ></modals-container>
        <table style="font-size: 0.85em; border-bottom: 2px solid gray" class="table table-bordered">
            <thead>
            <tr class="text-center">
                <th style="font-weight: bold;" colspan="6">{{$t(`message.${costsBudgetHeading}`)}}</th>
            </tr>
            <tr v-if="costTableThs && currentType">
                <th style="width: 20%;">{{$t(`message.${costTableThs[currentType].first}`)}}</th>
                <th style="width: 25%">{{$t(`message.${costTableThs[currentType].second}`)}}</th>
                <th style="width: 20%">{{$t(`message.${costTableThs[currentType].third}`)}}</th>
                <th style="width: 25%">{{$t(`message.${costTableThs[currentType].fourth}`)}}</th>
                <!-- <th v-if="costsBudgetData.length !== 0 &&  costsBudgetData[0].is_actual  && $store.getters.getAuth['userType'] === 'superuser'"
                    style="width: 5%">{{$t(`message.invoiced`)}}
                </th> -->
                <th class="text-center" v-if="$store.getters.getAuth['userType'] === 'superuser'">
                    <i v-if="!areAllRowsForOneTypeLocked() && $route.name.startsWith('Actual')"
                       @click="lockUnlockAllOneType(true)"
                       style="color: red; font-size: 1.6em; cursor: pointer;" class="fa fa-lock">
                    </i>
                    <i v-if="areAllRowsForOneTypeLocked() && $route.name.startsWith('Actual')"
                       @click="lockUnlockAllOneType(false)"
                       style="font-size: 1.6em; color: green; cursor: pointer;" class="fa fa-unlock">
                    </i>
                </th>
                <th>{{$t('message.showHide')}}</th>
            </tr>
            </thead>
            <tbody v-if="costsBudgetData.length !== 0">
            <tr v-for="(cost, index) in costsBudgetData" :key="index" 
                :class="{ borderTop: cost.show, lockedRow: cost.is_locked, additionalRow: cost.is_additional && !cost.is_actual, additionalRowLocked: cost.is_locked && cost.is_additional && !cost.is_actual, collapseRow: computedCollapseMap[cost.date.toString()] && !cost.show}">
                <td style="vertical-align: middle;"><span
                        v-show="cost.show === 1">{{removeDayFromDate(cost.date)}}</span></td>
                <td :class="{disabled: $store.getters.getAuth['userType'] !== 'superuser' && cost.is_locked}"
                    style="vertical-align: middle;">
                    <div v-if="!cost.is_locked" class="form-group select-category">
                        <select :id="'select-category-' + index" @change="calculateTotal(null, index)"
                                style="font-size: 0.95em; padding: 0; height: 22px" class="form-control">
                            <option v-for="(val, index) in computedTableCategories" :key="index" :value="val.value"
                                    :dataId="val.id"
                                    :selected="val.id === cost.category">
                                {{val.name}}, {{val.value}}
                            </option>
                        </select>
                    </div>
                    <div class="text-center" v-if="cost.is_locked">
                        {{showCategoryForLockedRow(cost.category).name}} -
                        {{showCategoryForLockedRow(cost.category).value}}
                    </div>
                </td>
                <td v-if="cost.amount !== 'no_data'" style="position: relative;">
                    <div @click="showHideRows(cost)"
                         v-if="cost.show && collapseMap[cost.date.toString()] && costLinesPerMonth(cost.date) > 1"
                         style="z-index: 1; position: absolute;height: 98%; width: 98%;">
                        <button :class="{'btn': true, 'btn-success': true, 'btn-block': true}"
                                style="font-size: 0.98em">{{$t('message.showMoreRows')}}
                        </button>
                    </div>
                    <input @keyup="calculateTotal($event, index)" step="0.01" v-bind:value="cost.amount"
                           style="width: 100%; border: none; vertical-align: middle;"
                           v-bind:class="{'budget': budgetYesActualNo ,  'actual': !budgetYesActualNo, 'disabled': cost.is_locked}"
                          
                    >
                </td>
                <td v-if="cost.amount === 'no_data'">
                    <button @click="cost.amount = 0" :class="{'btn': true, 'btn-secondary': true, 'btn-block': true}"
                            style="font-size: 0.98em">{{$t('message.clickToAddCosts')}}
                    </button>
                </td>
                <td style="position: relative; vertical-align: middle;">
                    <div @click="showHideRows(cost)"
                         v-if="cost.show && collapseMap[cost.date.toString()] && costLinesPerMonth(cost.date) > 1"
                         style="z-index: 1; position: absolute;height: 55%; width: 50%; bottom: 6px;">
                        {{formatNumber(totalCostsPerMonth(cost.date))}}
                    </div>
                    <span v-if="!(cost.show && collapseMap[cost.date.toString()] && costLinesPerMonth(cost.date) > 1)">{{formatNumber(cost.total)}}</span>
                    <div v-show="!(cost.show && collapseMap[cost.date.toString()] && costLinesPerMonth(cost.date) > 1)"
                         v-if="$store.getters.getAuth['userType'] === 'superuser' || !cost.is_locked"
                         @click="removeRow(cost)" @mouseover="showToolTip(index, true, 'showToolTipRemove')"
                         @mouseleave="showToolTip(-1, false, 'showToolTipRemove')"
                         :class="{'remove-row-save-date': true, 'add-row-same-date': true, disabled: $store.getters.getAuth['userType'] !== 'superuser' && cost.is_locked}">
                        -
                    </div>
                    <div v-if="$store.getters.getAuth['userType'] === 'superuser' || !cost.is_locked"
                         @click="addRowWithSameDate(cost.date, cost.is_locked, cost)"
                         @mouseover="showToolTip(index, true, 'showToolTipAdd')"
                         @mouseleave="showToolTip(-1, false, 'showToolTipAdd')"
                         :class="{'add-row-same-date': true, disabled: $store.getters.getAuth['userType'] !== 'superuser' && cost.is_locked}">
                        +
                    </div>

                    <span v-if="index === currentButtonIndex" class="tooltiptext"
                          v-bind:class="{ tooltiptextvisible_remove: showToolTipRemove }"> {{$t(`message.removeCostLine`)}}</span>
                    <span v-if="index === currentButtonIndex" class="tooltiptext"
                          v-bind:class="{ tooltiptextvisible_add: showToolTipAdd }"> {{$t(`message.addAnotherCostLine`)}} </span>
                </td>
                <!-- <td @click="setUnsavedWork"
                     v-if="cost.is_actual && $store.getters.getAuth['userType'] === 'superuser'">
                     <label style="margin: 6px 0 0 15px;" class="ui-checkbox ui-checkbox-success">
                         <input v-model="cost.is_invoiced" type="checkbox">
                         <span class="input-span"></span></label>
                 </td> -->
                <td v-if="$store.getters.getAuth['userType'] === 'superuser'" style="max-height: 37px">
                    <div style="margin-top: 6px; min-width: 56px" v-if="$route.name.startsWith('Actual')">
                        <label class="ui-checkbox ui-checkbox-danger lock-checkbox" style="">
                            <input @click="setLock($event, cost, false)" v-model="cost.is_locked" type="checkbox" style="max-height: 28px !important;">
                            <span class="input-span"></span></label>
                        <label v-if="cost.show  && isDateSingle(cost.date)"
                               class="ui-checkbox ui-checkbox-danger lock-checkbox">
                            <input :checked="areAllRowsWithSameDateLocked(cost.date)"
                                   @click="setLock($event, cost, true)"
                                   type="checkbox">
                            <span class="input-span"></span></label>
                    </div>
                </td>
                <td style="text-align: center">
                    <button v-if="cost.show && collapseMap[cost.date.toString()] && costLinesPerMonth(cost.date) > 1"
                            @click="showHideRows(cost)" class="btn btn-block btn-success showHideButton">
                        {{$t('message.show')}}
                    </button>
                    <button v-if="cost.show && !collapseMap[cost.date.toString()] && costLinesPerMonth(cost.date) > 1"
                            @click="showHideRows(cost)" class="btn btn-block btn-secondary showHideButton">
                        {{$t('message.hide')}}
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="text-center">
            <button v-if="(!computedAllBudgetLocked && $route.name.startsWith('Budget'))"
                    @click="setRows(true)" class="btn btn-success mr-2">{{$t('message.addRowWithNewDate')}}
            </button>
            <button :disabled="!unsavedWork" @click="updateData"
                    :class="{'btn': true, 'btn-primary': true, disabled: !unsavedWork}">{{$t('message.update')}} data
            </button>
            <button style="position: absolute; right: 0"
                    v-if="$store.getters.getAuth['userType'] === 'superuser' && $route.name.startsWith('Budget') && !computedAllBudgetLocked"
                    @click="lockUnlockBudget(true)" class="btn btn-danger">
                {{$t('message.lockAllBudget')}}
            </button>
            <button style="position: absolute; right: 0"
                    v-if="$store.getters.getAuth['userType'] === 'superuser' && $route.name.startsWith('Budget') && computedAllBudgetLocked"
                    @click="lockUnlockBudget(false)" class="btn btn-success">
                {{$t('message.unlockAllBudget')}}
            </button>
        </div>
    </div>
</template>

<script>
  import OkModal     from '../../modals/OkModal'
  import DialogModal from '../../modals/DialogModal'

  export default {
    name: 'CostsTable',
    props: ['categories', 'type', 'heading', 'sheet', 'lastCategory'],
    data () {
      return {
        collapseMap: {},
        blockUpdateButton: false,
        currentButtonIndex: -1,
        total: 0,
        budgetYesActualNo: true,
        unsavedWork: false,
        costsBudgetData: [],
        costsBudgetHeading: '',
        tableCategories: [],
        currentType: '',
        showToolTipAdd: false,
        showToolTipRemove: false,
        costTableThs: {
          'personnel': {
            first: 'date',
            second: 'chfPerHour',
            third: 'amountOfHours',
            fourth: 'total'
          },
          'material': {
            first: 'date',
            second: 'surcharge',
            third: 'price',
            fourth: 'total'
          },
          'foreign power': {
            first: 'date',
            second: 'surcharge',
            third: 'amount',
            fourth: 'total'

          },
          'inventory': {
            first: 'date',
            second: 'surcharge',
            third: 'amount',
            fourth: 'total'
          },
          'additional costs': {
            first: 'date',
            second: 'unit',
            third: 'amount',
            fourth: 'total'
          }
        },
      }
    },
    created () {
      this.getCostsBudgetData(this.$route.params['type'], this.$route.params['heading'])

      if (this.$route.name.substring(0, 6) === 'Budget')
        this.budgetYesActualNo = true
      else if (this.$route.name.substring(0, 6) === 'Actual')
        this.budgetYesActualNo = false
    },
    methods: {
      totalCostsPerMonth (month) {
        /* Calculate total costs per one month */
        let totalSum = 0
        for (let i = 0; i < this.costsBudgetData.length; i++) {
          if (this.costsBudgetData[i].date === month) {
            totalSum += this.costsBudgetData[i].total
          }
        }
        return totalSum
      },
      costLinesPerMonth (month) {
        /* Get number of cost lines per month */
        return this.costsBudgetData.filter(line => {
          return line.date === month
        }).length
      },
      passAddNote () {
        this.$emit('addNote')
      },
      passDeleteNote (param) {
        this.$emit('deleteNote', param)
      },
      confirmLockUnlockBudget (locked) {
        /** method for locking budget fields (individual types and on whole sheet) */
        const msg = locked ? this.$t('message.adminClosedBudget') : this.$t('message.adminOpenedBudget')
        this.update(this.apiPrefix, this.costsBudgetApiUrl + 'lock-unlock-budget/', this.sheet.id, {
          is_locked: locked,
          user: this.sheet.user.id,
          message: msg
        }).then(resp => {
          this.$emit('sheetChanged', resp.data)
          this.costsBudgetData = this.costsBudgetData.map(row => {
            if (!row.is_actual) {
              row.is_locked = locked
              return row
            }
            return row
          })
        })
      },
      calculateTotal (event, index) {
        // if input value is empty string, change it to 0, not NaN 
        if(event.target.value==="")
           event.target.value=0
        /** method for calculating total (amount * category) */
        this.unsavedWork = true
        if (event) {
            if(event.target.value === '-')
               this.costsBudgetData[index].amount = '-'
            else
               this.costsBudgetData[index].amount = parseFloat(event.target.value)
        }
        
        const select = document.getElementById(`select-category-${index}`)
        const options = Array.from(document.querySelector(`#select-category-${index}`).options)
        this.costsBudgetData[index].total = options[select.selectedIndex].value * this.costsBudgetData[index].amount
        this.costsBudgetData[index].category = parseInt(options[select.selectedIndex].getAttribute('dataid'))
      },
      updateData () {
        /* method for updating rows */

        // filter rows for update
        const dataForUpdate = this.costsBudgetData.filter(row => {
          // remove fows for which no data is inserted
          if (row.amount === 'no_data') {
            return false
          }

          // if user is superuser update all rows
          if (this.$store.getters.getAuth['userType'] === 'superuser') {
            return true
          }

          // if user is not superuser do not update rows that are locked
          if (this.$store.getters.getAuth['userType'] !== 'superuser' && !row.is_locked) {
            return true
          }
        })

        // lock budget only if the current costs are of type budget
        // if (this.$route.name.startsWith('Budget') && this.costsBudgetData.length) {
        //   this.lockBudget()
        // }

        if (this.blockUpdateButton) {
          return
        }

        this.blockUpdateButton = true
        // bulk update rows
        this.post(this.apiPrefix, this.costsBudgetApiUrl + 'bulk/', `?category__type=${this.$route.params['type']}`, dataForUpdate)
          .then(resp => {
            this.unsavedWork = false
            this.costsBudgetData = resp.data.data

            this.blockUpdateButton = false
            this.setRows()

            this.$modal.show(OkModal, {
                text: this.$t('message.costsUpdated'),
                modalClass: this.modalClasses.okSuccessClass
              },
              {
                width: this.modalWidth(),
                height: 'auto'
              })
          })
          .catch(() => {
            this.unsavedWork = false
          })

      },
      getCostsBudgetData (categoryType, heading) {
        /** method for getting costs */
        this.getList(this.apiPrefix, this.costsBudgetApiUrl,
          `?sheet_id=${this.$route.params['id']}&category__type=${categoryType}&is_actual=${this.setCostTypeQueryParams()}`)
          .then(resp => {
            this.currentType = categoryType
            if(heading === 'work')
              this.costsBudgetHeading = 'job'
            else
              this.costsBudgetHeading = heading
            this.costsBudgetData = resp.data
            this.tableCategories = this.categories[categoryType]
            this.setRows()
          })
          .catch()
      },
      setCostType () {
        /** Set cost type for newly created rows (not yet added to database) */
        return this.$route.name.startsWith('Actual')
      },
      paddingOfActualCostRows (rows) {
        const months = []
        const startDate = this.$moment(this.sheet.start_date)
        const currentDate = this.$moment(new Date())

        while (currentDate.diff(startDate, 'months', true) >= 0) {
          months.push(startDate.format('YYYY-MM-DD'))
          startDate.add(1, 'month')
        }

        for (let i = 0; i < months.length; i++) {
          if (!rows.filter(row => row['date'] === months[i]).length) {
            const row = this.createRow(this.$moment(months[i]).format(this.formatBackendString), 1)
            if (!row) {
              continue
            }

            if (!this.costsBudgetData.map(obj => {return obj.date}).includes(row.date)) {
              rows.push(row)
            }
          }
        }
      },
      addRowsForActualCosts (last_date = null) {
        /** Method for adding rows based on the last date or start date of the sheet */
        let date = null

        // get year and week for start_date, or last date if already present
        if (last_date) {
          date = last_date
        } else {
          date = this.sheet.start_date
        }

        const rows = []
        let monthsDifference = this.$moment(new Date()).diff(date, 'months', true)
        if (monthsDifference < 0) {
          return []
        }

        const monthsDifferenceReminder = monthsDifference % 1
        monthsDifference = monthsDifferenceReminder > 0.1 ? Math.ceil(monthsDifference) : Math.floor(monthsDifference)

        if (monthsDifference >= 1) {
          let k = 0
          for (let i = 0; i < Math.ceil(monthsDifference); i++) {
            const row = this.createRow(this.$moment(date).add(k, 'months').format(this.formatBackendString), 1)
            if (!row) {
              return rows
            }
            k += 1

            if (!this.costsBudgetData.map(obj => {return obj.date}).includes(row.date)) {
              rows.push(row)
            }
          }
        }
        this.paddingOfActualCostRows(rows)
        return rows
      },
      formatNumber (input) {
        // format is function in generalMixin.js
        return this.format(input)
      },
      setRows (manual = false) {
        /** Method for setting rows upon getting the data or adding rows manually*/
        // IF THERE IS NO ROWS
        if (this.costsBudgetData.length === 0) {
          // if rows are for actual costs
          if (this.$route.name.startsWith('Actual')) {
            const rows = this.addRowsForActualCosts()
            this.costsBudgetData.push(...rows)
            this.costsBudgetData = this.costsBudgetData.sort((a, b) => {
              return this.$moment(a['date']) > this.$moment(b['date']) ? 1 : -1
            })

            this.costsBudgetData = this.costsBudgetData.sort((a, b) => {
              if(a['date'] === b['date']){
                if(a['show']){
                  return -1;
                }

                if(b['show']){
                  return 1;
                }
              }
            })
          } else {
            // if rows are for budget
            // if there are no rows and budget is locked do not add new rows
            if (!this.sheet.budget_locked) {
              const row = this.createRow(this.$moment(this.sheet.start_date).format(this.formatBackendString), 1)
              if (row) {
                this.costsBudgetData.push(row)
              }
            }
          }
          this.tableCategories = this.categories[this.$route.params['type']]
          // IF THERE ARE ROWS PRESENT
        } else if ((this.costsBudgetData.length !== 0 && this.$route.name.startsWith('Actual')) || manual) {
          if (this.$route.name.startsWith('Actual')) {
            const lastDate = this.costsBudgetData[this.costsBudgetData.length - 1]
            const rows = this.addRowsForActualCosts(lastDate.date)
            this.costsBudgetData.push(...rows)
            this.costsBudgetData = this.costsBudgetData.sort((a, b) => {
              return this.$moment(a['date']) > this.$moment(b['date']) ? 1 : -1
            })

            this.costsBudgetData = this.costsBudgetData.sort((a, b) => {
              if(a['date'] === b['date']){
                if(a['show']){
                  return -1;
                }

                if(b['show']){
                  return 1;
                }
              }
            })
          } else {
            const lastDate = this.costsBudgetData[this.costsBudgetData.length - 1]
            const row = this.createRow(this.$moment(lastDate.date).add(1, 'months').format(this.formatBackendString), 1)
            if (row) {
              this.costsBudgetData.push(row)
            }
          }
        }

        // set or update collapse data map
        this.createUpdateMonthsCollapseMap()
      },
      addRowWithSameDate (date, locked, cost) {
        /** Method for adding row with same date */
        if (!locked) {
          // show row if previously hidden
          this.showHideRows(cost, true)

          const row = this.createRow(this.$moment(date).format(this.formatBackendString), 0)
          const index = this.reverseFindByProperty(this.costsBudgetData, 'date', date)
          this.costsBudgetData.splice(index + 1, 0, row)
        }
      },
      createRow (date, show) {
        /** Method for creating single row */
        if (this.categories[this.$route.params['type']].length !== 0) {
          return {
            'date': date,
            'amount': this.$route.name.startsWith('Actual') ? 'no_data' : 0,
            'total': 0,
            'sheet': this.sheet.id,
            'is_actual': this.setCostType(),
            'category': this.categories[this.$route.params['type']][0]['id'],
            'user': this.sheet.user.id,
            'show': show,
            'is_additional': this.sheet.additional_budget_approved !== 0,
            'uuid': this.uuidv4()
          }
        } else {
          let msg = this.$t('message.pleaseCreateCategory')

          this.$modal.show(OkModal, {
              text: msg,
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        }
      },
      removeRow (row) {
        /** Method for showing modal for confirming removing row */

        // if row is locked and user is not superuser prevent removal
        if (row.is_locked && this.$store.getters.getAuth['userType'] !== 'superuser') {
          return
        }

        // check if row can be removed (do not leave gaps between months)
        if (!this.checkIfRowCanBeRemoved(row)) {
          return
        }

        // if row has id it is already saved in the database
        if (row['id']) {
          this.$modal.show(DialogModal, {
              text: `${this.$t('message.deleteCostRow')}.`,
              param: row,
              textColor: '#c44133',
              event: 'confirmDeleteRow'
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        } else {
          // remove row that is not yet saved in the db without need for confirmation
          if (row['show']) {
            const rowsWithoutShow = this.costsBudgetData.filter(obj => {
              return obj['date'] === row['date'] && row['uuid'] !== obj['uuid']
            })
            if (rowsWithoutShow.length) {
              const newRowWithShow = rowsWithoutShow[0]
              newRowWithShow['show'] = 1
            }
          }

          this.costsBudgetData = this.costsBudgetData.filter(obj => {
            return row['uuid'] !== obj['uuid']
          })
        }
      },
      confirmDeleteRow (data) {
        /** Method for deleting row upon confirming the deletion of already saved row */
        this.delete(this.apiPrefix, this.costsBudgetApiUrl, data.id)
          .then(() => {
            this.checkIfShowTrueRowDeleted(data)
            this.costsBudgetData = this.costsBudgetData.filter(obj => {
              return obj.id !== data.id
            })

            if (data.show === 1) {
              this.updateData()
            }
          }).catch(err => {
          console.log(err)
        })
      },
      checkIfShowTrueRowDeleted (row) {
        /** set row to show date if row with same visible date was deleted */
        let index = this.findByProperty(this.costsBudgetData, 'id', row.id)
        if (this.costsBudgetData[index] && this.costsBudgetData[index].show) {
          if (!(typeof this.costsBudgetData[index + 1] === 'undefined') && !this.costsBudgetData[index + 1].show) {
            this.costsBudgetData[index + 1].show = 1
          }
        }
      },
      checkIfRowCanBeRemoved (row) {
        /** check if row can be deleted (eg. there must not be a month gap between two rows) */
        if (this.checkDateCount(row.date) > 1) {
          return true
        } else {
          const index = this.findByProperty(this.costsBudgetData, 'date', row.date)
          if ((this.costsBudgetData.length - 1) === index) {
            return true
          } else {
            this.$modal.show(OkModal, {
                text: this.$t('message.deleteRowNotAllowed'),
                modalClass: this.modalClasses.okErrorClass
              },
              {
                width: this.modalWidth(),
                height: 'auto'
              })
            return false
          }
        }
      },
      setUnsavedWork () {
        /** set unsaved work if somtehing has changed so that user cant leave page without confirming */
        this.unsavedWork = true
      },
      setLock (event, cost, multi) {
        /** Set unsaved work to true if triggered, if multi is true lock all rows with same date, else just the clicked one */
        this.setUnsavedWork()
        if (multi) {
          const rowsWithSameDate = this.costsBudgetData.filter(obj => {
            return obj.date === cost.date
          })

          for (const cost of rowsWithSameDate) {
            cost.is_locked = event.target.checked
          }
        }
      },
      areAllRowsWithSameDateLocked (date) {
        /** Check if all rows with same date are locked */
        const rowsWithSameDate = this.costsBudgetData.filter(obj => {
          return obj.date === date
        })

        for (const row of rowsWithSameDate) {
          if (!row.is_locked) {
            return false
          }
        }
        return true
      },
      areAllRowsForOneTypeLocked () {
        /** Checks if all rows for one type are locked */
        if (!this.costsBudgetData.length) {
          return false
        }

        for (const row of this.costsBudgetData) {
          if (!row.is_locked) {
            return false
          }
        }
        return true
      },
      lockUnlockAllOneType (lock) {
        /** Method that locks or unlocks all rows for one type */
        this.setUnsavedWork()
        for (const row of this.costsBudgetData) {
          row.is_locked = lock
        }
      },
      lockUnlockBudget (locked) {
        /** Method for showing modal if admin wants to lock or unlock whole budget*/
        const msg = locked ? this.$t('message.areYouSureLock') : this.$t('message.areYouSureUnlock')

        this.$modal.show(DialogModal, {
            text: msg,
            param: locked,
            textColor: '#c44133',
            event: 'confirmLockUnlock'
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })

      },
      showCategoryForLockedRow (categoryId) {
        /** Method for showing category for rows that are locked (showing just the text not selected option)*/
        const category = this.tableCategories.filter(row => {
          return row.id === categoryId
        })

        if (category.length) {
          return category[0]
        }
        return ''
      },
      isDateSingle (date) {
        /** method for checking if one or tow checkboxes for locking rows should be shown beside row*/
        return this.costsBudgetData.filter(row => {
          return row.date === date
        }).length > 1
      },
      checkDateCount (date) {
        /** Helper method to determine if there is more rows with same date (used in checkIfRowCanBeRemoved) */
        let count = 0
        for (const row of this.costsBudgetData) {
          if (row['date'] === date) {
            count++
          }
        }
        return count
      },
      setCostTypeQueryParams () {
        /** Method for setting cost type as query param in getCostBudgetData */
        if (this.$route.name.startsWith('Budget')) {
          return 'False'
        }
        return 'True'
      },
      showToolTip (index, value, type) {
        this.currentButtonIndex = index
        this[type] = value
      },
      createUpdateMonthsCollapseMap () {
        /** Method for creating and updating map with data needed to decide which rows to show/hide */
        if (this.costsBudgetData.length) {
          const currentMonth = this.$moment().format('YYYY-MM-DD').toString()
          for (const row of this.costsBudgetData) {
            this.collapseMap[row.date.toString()] = currentMonth !== row.date.toString()
          }
        }
      },
      showHideRows (cost, onlyIfHidden = false) {
        if (onlyIfHidden) {
          if (this.collapseMap[cost.date.toString()]) {
            this.collapseMap[cost.date.toString()] = !this.collapseMap[cost.date.toString()]
            this.collapseMap = JSON.parse(JSON.stringify(this.collapseMap))
          }
        } else {
          this.collapseMap[cost.date.toString()] = !this.collapseMap[cost.date.toString()]
          this.collapseMap = JSON.parse(JSON.stringify(this.collapseMap))
        }

      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.unsavedWork) {
        const answer = window.confirm(this.$t('message.leavePage'))
        if (answer) {
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }
    },
    watch: {
      categories: {
        handler () {
          // add row(s) if first category is added
          if (this.categories[this.$route.params['type']].length === 1 && this.lastCategory === this.$route.params['type']) {
            this.setRows()
          }
        },
        deep: true
      }
    },
    computed: {
      computedTableCategories () {
        return this.tableCategories
      },
      computedAllBudgetLocked () {
        return this.sheet.budget_locked
      },
      computedCollapseMap () {
        return this.collapseMap
      }
    }
  }
</script>

<style scoped>
    #costs-table {
        position: relative;
    }

    table td {
        padding: 3px;
    }

    table th {
        padding: 5px;
    }

    .select-category {
        margin: 0;
        padding: 0;
    }

    .add-category-button {
        position: absolute;
        right: 45px;
        bottom: 33px;
        cursor: pointer;
        height: 25px;
        width: 25px;
    }

    .add-category-button-plus {
        font-size: 0.9em;
        position: absolute;
        top: 6px;
        left: 6.5px
    }

    .add-row-same-date {
        background-color: #0b93d5;
        color: white;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        border: 3px solid white;
        width: 30px;
        text-align: center;
        font-size: 1.2em;
        cursor: pointer;
    }

    .add-row-additional-budget {
        background-color: #2ecc71;
    }

    .remove-row-save-date {
        background-color: #e74c3c;
        position: absolute;
        right: 30px;
        top: 0;
    }

    .borderTop {
        border-top: 2px solid gray;
    }

    .tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #000;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px;
        position: absolute;
        top: 10px;
        right: 65px;
        z-index: 1;
    }

    .tooltiptextvisible_add {
        visibility: visible;
        margin-left: -2%;
        margin-top: -3%;
    }

    .tooltiptextvisible_remove {
        visibility: visible;
        margin-left: -4%;
        margin-top: -3%;
    }

    .lock-checkbox {
        display: inline;
        margin-top: 6px;
    }

    .lockedRow {
        background: rgba(255, 0, 0, 0.1);
    }

    .disabled {
        pointer-events: none;
    }

    .additionalRow {
        background-color: rgba(144, 238, 144, 0.4);
    }

    .additionalRowLocked {
        background-color: rgba(255, 0, 0, 0.4);
    }

    .budget {
        background-color: #ff9cbb
    }

    .actual {
        background-color: #cfcacb;
    }

    .collapseRow {
        display: none;
    }

    .showHideButton {
        cursor: pointer;
        font-size: 0.95em;
    }

</style>